import { useEffect, useState } from "react";
import { useUniversalContext } from "@cxc/react-universal-components";

export const useLocale = (): { language: string, country: string, locale: string } => {
  const [language, setLanguage] = useState("en");
  const [country, setCountry] = useState("us");

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { language: locale }: { language: string } = useUniversalContext();

  useEffect(() => {
    if (locale) {
      const lc = getLanguageAndCountry(locale);
      setLanguage(lc.language);
      setCountry(lc.country);
    }
  }, [locale]);

  return { language, country, locale };
};

export const getLanguageAndCountry = (locale: string): { language: string, country: string } => {
  if (!locale) {
    throw new Error("Missing locale. Cannot determine country.");
  }
  const languageCountryPair = locale.split("-");
  if (languageCountryPair?.length !== 2 || languageCountryPair[1].length <= 0) {
    throw new Error(
      `Locale is not in the proper format and country cannot be determined: ${locale}`
    );
  }
  return {
    language: languageCountryPair[0],
    country: languageCountryPair[1]
  };
};
